import {
  ChangeDetectorRef,
  Component,
  forwardRef,
  Inject,
  Input,
  OnInit
} from '@angular/core';

import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { NgbActiveModal }     from '@ng-bootstrap/ng-bootstrap';
import { NgForm }             from '@angular/forms';
import { TranslateService }   from '@ngx-translate/core';

import { CompanyService }              from '../companies/company.service';
import { FlipperSidesModel }           from '../shared/components/flipper/typings/flipper.sides';
import { MessagesService }             from '../messages/messages.service';
import { ReminderDefaultsModel }       from './typings/reminders.defaults';
import { RemindersModel }              from './typings/reminders';
import { RemindersService }            from './reminders.service';
import { RemindersSufficientSMSModel } from './typings/reminders.sufficient-sms';
import { TemplatedWordingService }     from '../templates/templated-wording.service';

@Component({
  selector   : 'reminders-send',
  template: require('./reminders.send.component.html')
})
export class SendRemindersComponent implements OnInit {
  @BlockUI('sendRemindersBackBlock')  backBlock : NgBlockUI;
  @BlockUI('sendRemindersFrontBlock') frontBlock: NgBlockUI;

  @Input() defaults : ReminderDefaultsModel;

  activeSide: FlipperSidesModel = 'front';

  reminders: RemindersModel;
  warning  : RemindersSufficientSMSModel;

  documentPlaceholders: Array<any> = [];
  emailPlaceholders   : Array<any> = [];

  constructor (
    public  activeModal            : NgbActiveModal,
    private changeDetectorRef      : ChangeDetectorRef,
    public companyService          : CompanyService,
    private messagesService        : MessagesService,
    @Inject(forwardRef(() => RemindersService))
    private remindersService       : RemindersService,
    private templatedWordingService: TemplatedWordingService,
    private translateService       : TranslateService
  ) {}

  ngOnInit () : void {
    this.reminders = {
      document_message: this.defaults.document_service_reminder,
      email_message   : this.defaults.email_service_reminder,
      end_date        : '',
      message_type    : 'default',
      sms_message     : this.defaults.sms_service_reminder,
      start_date      : this.defaults.start_date
    };

    this.documentPlaceholders = [
      {
        message    : this.translateService.instant('GENERAL_SPACE.MESSAGE_PLACEHOLDERS.NEXT_SERVICE_DATE'),
        placeholder: '%nextserv%'
      },
      {
        message    : this.companyService.labels.rego.toLowerCase(),
        placeholder: '%regnumbr%'
      },
      {
        message    : this.translateService.instant('GENERAL_SPACE.MESSAGE_PLACEHOLDERS.CUSTOMER_FIRST_NAME'),
        placeholder: '%custfirstname%'
      },
      {
        message    : this.translateService.instant('GENERAL_SPACE.MESSAGE_PLACEHOLDERS.CUSTOMER_LAST_NAME'),
        placeholder: '%custlastname%'
      },
      {
        message    : this.translateService.instant('GENERAL_SPACE.MESSAGE_PLACEHOLDERS.CUSTOMER_ADDRESS', { num: 1 }),
        placeholder: '%custaddress1%'
      },
      {
        message    : this.translateService.instant('GENERAL_SPACE.MESSAGE_PLACEHOLDERS.CUSTOMER_ADDRESS', { num: 2 }),
        placeholder: '%custaddress2%'
      },
      {
        message    : this.translateService.instant('GENERAL_SPACE.MESSAGE_PLACEHOLDERS.CUSTOMER_SUBURB'),
        placeholder: '%custsuburb%'
      },
      {
        message    : this.translateService.instant('GENERAL_SPACE.MESSAGE_PLACEHOLDERS.CUSTOMER_STATE'),
        placeholder: '%custstate%'
      },
      {
        message    : this.translateService.instant('GENERAL_SPACE.MESSAGE_PLACEHOLDERS.CUSTOMER_POSTCODE'),
        placeholder: '%custpostcode%'
      },
      {
        message    : this.translateService.instant('GENERAL_SPACE.MESSAGE_PLACEHOLDERS.COMPANY_NAME'),
        placeholder: '%companyname%'
      },
      {
        message    : this.translateService.instant('GENERAL_SPACE.MESSAGE_PLACEHOLDERS.COMPANY_ADDRESS', { num: 1 }),
        placeholder: '%compaddress1%'
      },
      {
        message    : this.translateService.instant('GENERAL_SPACE.MESSAGE_PLACEHOLDERS.COMPANY_ADDRESS', { num: 2 }),
        placeholder: '%compaddress2%'
      },
      {
        message    : this.translateService.instant('GENERAL_SPACE.MESSAGE_PLACEHOLDERS.COMPANY_SUBURB'),
        placeholder: '%compsuburb%'
      },
      {
        message    : this.translateService.instant('GENERAL_SPACE.MESSAGE_PLACEHOLDERS.COMPANY_STATE'),
        placeholder: '%compstate%'
      },
      {
        message    : this.translateService.instant('GENERAL_SPACE.MESSAGE_PLACEHOLDERS.COMPANY_POSTCODE'),
        placeholder: '%comppostcode%'
      },
      {
        message    : this.translateService.instant('GENERAL_SPACE.MESSAGE_PLACEHOLDERS.VEHICLE_MAKE'),
        placeholder: '%vehiclemake%'
      },
      {
        message    : this.translateService.instant('GENERAL_SPACE.MESSAGE_PLACEHOLDERS.VEHICLE_MODEL'),
        placeholder: '%vehiclemodel%'
      }
    ];

    this.emailPlaceholders = [
      {
        message: this.translateService.instant('SERVICE_REMINDERS_SPACE.REGO_PLACEHOLDER_MESSAGE', {
          rego: this.companyService.labels.rego.toLowerCase()
        }),
        placeholder: '%regnumbr%'
      },
      {
        message    : this.translateService.instant('SERVICE_REMINDERS_SPACE.SERVICE_DATE_PLACEHOLDER_MESSAGE'),
        placeholder: '%nextserv%'
      },
      {
        message: this.translateService.instant('SERVICE_REMINDERS_SPACE.GENERIC_PLACEHOLDER_MESSAGE', {
          rego: this.companyService.labels.rego.toLowerCase()
        })
      },
      {
        message    : this.translateService.instant('SERVICE_REMINDERS_SPACE.FULL_CUSTOMER_NAME_MESSAGE'),
        placeholder: '%custfullname%'
      }
    ];
  }

  addTemplates () : void {
    this.templatedWordingService.addTemplate('document')
    .then(( templates : Array<any> ) => {
      templates.forEach(template => {
        this.reminders.document_message = this.reminders.document_message
          ? this.reminders.document_message + '\n\n' + template.wording
          : template.wording;
      });
    });
  }

  buySms () : void {
    this.backBlock.start();

    this.remindersService.buySms(this.warning.sms_needed)
    .then(() => this.sendReminders())
    .catch(err => this.messagesService.error(err))
    .finally(() => this.backBlock.stop());
  }

  changeSide ( side : FlipperSidesModel = 'back' ) : void {
    this.activeSide = side;

    this.changeDetectorRef.detectChanges();
  }

  confirm ( form : NgForm ) : void {
    if ( this.reminders.message_type !== 'email' && this.reminders.message_type !== 'document' ) {
      this.frontBlock.start();

      this.remindersService.verifySmsAvailability(this.reminders)
      .then((data : RemindersSufficientSMSModel) => {
        if ( data.sufficient_sms ) {
          this.sendReminders();
        }
        else {
          this.warning = data;

          this.changeSide();
        }
      })
      .catch(err => {
        this.messagesService.error(err);
      })
      .finally(() => this.frontBlock.stop());
    }
    else {
      this.sendReminders();
    }
  }

  sendReminders ( asEmail = false ) : void {
    this.backBlock.start();

    this.reminders.email_only = asEmail;

    this.remindersService.confirmReminders(this.reminders)
    .then(data => {
      if ( data.warning ) {
        this.messagesService.show(data.message, 'warning');
      }
      else {
        this.activeModal.close();

        this.messagesService.show(data.message, 'success');
      }
    })
    .catch(err => this.messagesService.error(err))
    .finally(() => this.backBlock.stop());
  }

  smsLengthWarning () : string {
    if ( this.reminders.sms_message.length <= 150 ) {
      return 'text-success';
    }
    else if ( this.reminders.sms_message.length < 160 ) {
      return 'text-warning';
    }
    else {
      return 'text-danger';
    }
  }
}
